/*
 * @Author       : he bo
 * @Date         : 2021-02-26 11:37:07
 * @LastEditors  : he bo
 * @LastEditTime : 2021-03-13 20:11:36
 * @FilePath     : /fe-ts-basic-platform/src/store/reducer/basic.js
 */
const initialState = {
  accountInfo: {},
  currentStation: 0,
  currentStationInfo: {},
  openKeys: ['/'], // 展开的菜单
  selectedKeys: [], // 选中的菜单
  authList: {}, // 权限列表
  projectList: [], // 子项目列表
  isShowInitLoading: true,
  projectMap: [],
  menuList: [
    {
      name: '首页',
      icon: 'home',
      key: '/',
      path: '/',
      auth: { view: 1 },
    },
  ],
  basicData: [],
  basicMap: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'GET_LOGIN_INFO':
      return {
        ...state,
        accountInfo: { ...action.payload },
      };
    case 'SET_CURRENT_STATION':
      return {
        ...state,
        currentStation: action.payload,
      };
    case 'SET_CURRENT_STATION_INFO':
      return {
        ...state,
        currentStationInfo: action.payload,
      };
    case 'CHANGE_STATION_NAME':
      return {
        ...state,
        stationName: action.payload,
      };
    case 'CHANGE_PATH':
      return {
        ...state,
        openKeys: action.payload,
      };
    case 'SELECT_PATH':
      return {
        ...state,
        selectedKeys: action.payload,
      };
    case 'GET_AUTH_LIST':
      return {
        ...state,
        authList: action.payload,
      };
    case 'GET_MENU_LIST':
      return {
        ...state,
        menuList: action.payload.menuList,
      };
    case 'INIT_LOADING':
      return {
        ...state,
        isShowInitLoading: action.payload,
      };
    case 'GET_PROJECT_LIST':
      return {
        ...state,
        projectList: action.payload,
      };
    case 'GET_PROJECT_MAP':
      return {
        ...state,
        projectMap: action.payload,
      };
    case 'GET_BASIC_DATA':
      // eslint-disable-next-line no-case-declarations
      const basicMap = {};
      action.payload.map((item) => {
        basicMap[item.englishField] = {
          value: item.value,
          id: item.id,
          type: item.type,
        };
      });
      return {
        ...state,
        basicData: action.payload,
        basicMap,
      };
    default:
      return state;
  }
};
